import { shallowRef } from 'vue'
import { appConfig } from '../config/env'

const key = `kg-web:auth:${appConfig.siteCode || 'default'}`
const legacyTokenKey = 'kaiyun_web_token'
const legacyUserKey = 'kaiyun_web_user'
function readSession() {
  try {
    let value = null
    try { value = JSON.parse(localStorage.getItem(key) || 'null') } catch { /* 损坏的旧记录不能覆盖当前身份。 */ }
    const token = localStorage.getItem(legacyTokenKey)
    if (token) {
      if (token === value?.token && value?.memberId) return value
      return { token, username: localStorage.getItem(legacyUserKey) || '' }
    }
    if (value?.token && value?.memberId) {
      localStorage.setItem(legacyTokenKey, value.token)
      localStorage.setItem(legacyUserKey, value.username || '')
    }
    return value?.token && value?.memberId ? value : null
  } catch { return null }
}
export const memberSession = shallowRef(readSession())
export const getToken = () => memberSession.value?.token || ''
export function saveSession(value) {
  if (!value?.token || !value?.memberId) throw new Error('登录响应不完整，请重试')
  const session = { token: value.token, memberId: value.memberId, username: value.username }
  localStorage.setItem(key, JSON.stringify(session))
  localStorage.setItem(legacyTokenKey, session.token)
  localStorage.setItem(legacyUserKey, session.username)
  memberSession.value = session
}
export function clearSession() {
  localStorage.removeItem(key)
  localStorage.removeItem(legacyTokenKey)
  localStorage.removeItem(legacyUserKey)
  memberSession.value = null
}
// dev 的服务层和 main 的页面使用同一个 Web 登录身份，不发起额外认证。
function synchronizeLegacySession() {
  if (!localStorage.getItem(legacyTokenKey)) {
    localStorage.removeItem(key)
    memberSession.value = null
    return
  }
  memberSession.value = readSession()
}
window.addEventListener('app:web-session-changed', synchronizeLegacySession)
window.addEventListener('storage', (event) => {
  if ([legacyTokenKey, legacyUserKey].includes(event.key)) synchronizeLegacySession()
  else if (event.key === key || event.key === null) memberSession.value = readSession()
})
